// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import GenerictListTab from "./../../factories/generic-list-tab";
import Bao from "../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";

class ConfigurationItem100QualificationViewModel extends GenerictListTab {
    ConfigurationItem: any;
    ExpirationEnabled = ko.observable();
    /**
     * Checks if certificate upload required from QualificationType
     */
    CertificateUploadRequired = ko.observable();

    /**
     * action key for ExtendQualification button 
     */
    ConfigurationItem100QualificationTabExtendQualificationActionKey = 'ConfigurationItem100QualificationTabExtendQualification';
    
    OnlyValidQualifications: KnockoutObservable<boolean> = ko.observable();

    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.DialogWidth = 500;
        this.ConfigurationItem = parent;

        /**
         * 'show only valid' checkbox click event
         */
        this.OnlyValidQualifications.subscribe((value) => {
            this.Get();
        });
    }
    CustomFilter()  {
         return [{
            Key: 'onlyvalidqualifications',
            Value: this.OnlyValidQualifications()
         }]
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        let result = true;
        def.resolve(result);
        return def.promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item));
        }
    }

    /**
     * toolbar menu 'ExtendQualification' click event
     * @param action toolbar button click events
     */
    CustomToolbarClick = (action: Interfaces.Bao.BaoMenuItem) => {
        if (this.TabPage.IsActiveTab()) {
            switch (ko.unwrap(action.ActionKey)) {
                case this.ConfigurationItem100QualificationTabExtendQualificationActionKey:
                    if (this.Selection()[0] != null) {
                        this.ExtendQualification();
                    }
                    break;
            }
        }
    };

    /**
     * enable toolbar menu buttons when tab's item is selected
     */
    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            let key = ko.unwrap(button.ActionKey);
            let enabled: KnockoutObservable<boolean> = (button.Enabled) as KnockoutObservable<boolean>;
            if (key == this.ConfigurationItem100QualificationTabExtendQualificationActionKey) {
                enabled(this.Selection() != null && this.Selection().length == 1);
            }
        });
    }

    /**
     * extend selected qualification
     */
    ExtendQualification = (): JQueryPromise<void> => {
        this.TabPage.IsLoading(true);
        let def = $.Deferred<void>();
        let selectedItemId = this.Selection()[0].PrimaryKeyValue;
        Bao.post('ConfigurationItem100QualificationTab/ExtendQualification', JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: this.GetParentId(),
            id: selectedItemId
        })).then((result: any) => {
            if(result.Result === true){
                    this.TabPage.DirtyFlag(true);
                    this.Dialog(result.Model);
                    def.resolve();
            }else{
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                def.resolve();
            }
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
        return def.promise();
    };
    
    /**
     * overridden this method to set 'OnlyValidQualifications' value before calling init method
     * and to get documents after init
     * @returns jquery promise
     */
    init(): JQueryPromise<void> {
        let def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        $.when(this.GetUserProfile()).then(() => {
            super.init().always(() => {
                this.TabPage.IsLoading(false);
                def.resolve();
            });
        });
        return def.promise();
    }

    /**
     * gets 'OnlyValidQualifications' value from UserProfile
     * @returns true or false
     */
    GetUserProfile = (): JQueryPromise<void> => {
        let def = $.Deferred<void>();
        Bao.post('ConfigurationItem100QualificationTab/GetUserProfile', JSON.stringify({}))
        .then((result) => {
            this.OnlyValidQualifications(result.onlyValidQualifications === "true" ? true : false);
            def.resolve();
        });
        return def.promise();
    };

    /**
     * Overridden to get close event of dialog
     * Gets called by the standard way or when a qualification gets extended
     * when the qualification gets extended, the entire qualification model is given as input parameter,
     * otherwhise only the Configurationitem100QualificationId is given as parameter
     * @param id Primary key value
     * @returns Void
     */
    Dialog(model: any): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        let id = null
        if (model != null && model.hasOwnProperty('ConfigurationItem100QualificationId')) {
            id = model.ConfigurationItem100QualificationId;
        }
        if (model != null && !model.hasOwnProperty('ConfigurationItem100QualificationId')) {
            id = model;
        }
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            let dialog = new BaoDialog(Bao.Session.ApplicationName);
            let okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                let item = dialog.ViewModel();
                delete item.Parent;
                this.ItemCompleteCheck.call(this, item).then((validateResult) => {
                    if (validateResult) {
                        this.Save(ko.map.toJS(item)).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                });
            });
            let cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {                
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            let vm = ko.map.fromJS(result.Model);

            //if we are extending a qualification vm contains an empty model and we want the content from the input parameter instead
            if (model != null && model.hasOwnProperty('ConfigurationItem100QualificationId')) {
                let modelvalue = ko.map.fromJS(model);
                modelvalue.Parent = this;
                dialog.ViewModel(modelvalue);                
            }
            else {
                vm.Parent = this;
                dialog.ViewModel(vm);
            }
            dialog.Template(result.Template);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }

}
export default ConfigurationItem100QualificationViewModel;